import { render, staticRenderFns } from "./SetCustomReminderModal.vue?vue&type=template&id=82674da4&scoped=true"
import script from "./SetCustomReminderModal.vue?vue&type=script&lang=ts"
export * from "./SetCustomReminderModal.vue?vue&type=script&lang=ts"
import style0 from "./SetCustomReminderModal.vue?vue&type=style&index=0&id=82674da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82674da4",
  null
  
)

export default component.exports